import script from "./HomeViewTEST.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewTEST.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewTEST.vue?vue&type=style&index=0&id=fb32868e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb32868e"]])

export default __exports__